export const enum TriggerEvent {
  ACCEPT_ROADSHOW_DISCLAIMER = 'ACCEPT_ROADSHOW_DISCLAIMER',
  LOGOUT = 'LOGOUT',
  TIMEOUT_LOGOUT = 'TIMEOUT_LOGOUT',
  SLIDE_CHANGE = 'SLIDE_CHANGE',
  WINDOW_CLOSE = 'WINDOW_CLOSE',
  VIDEO_ONLY_PAUSE = 'VIDEO_ONLY_PAUSE',
  PRESENTATION_MEDIA_PAUSE = 'PRESENTATION_MEDIA_PAUSE',
  TIME_ACCUMULATOR_COUNTING = 'TIME_ACCUMULATOR_COUNTING',
  LINK_VIEW = 'LINK_VIEW',
  COMMERCIAL_VIDEO_VIEW = 'COMMERCIAL_VIDEO_VIEW',
  DEAL_DOCUMENT_VIEW = 'DEAL_DOCUMENT_VIEW',
  DEAL_DOCUMENT_DOWNLOAD = 'DEAL_DOCUMENT_DOWNLOAD',
}
